import sensors from '@/utils/sensors/sensors_config'
//注释部分只需服务端做
// 登录/注册/注销
export default {
    //序号10-LoginInitiation-登录发起    
    $loginInit(login_mode: any, if_SMS_pass: any, if_logoff_apply: any, apply_day: any) {
        sensors.track('LoginInitiation', {
            login_mode,//	登录方式
            if_SMS_pass,//	是否通过短验
            if_logoff_apply,//	是否在注销申请中
            apply_day,//	申请注销剩余天数
        })
    },
    // //序号11-LoginResult-登录结果
    // $loginResult(login_mode: any, if_success: any, if_logoff_apply: any, apply_day: any) {
    //     sensors.track('LoginResult', {
    //         login_mode,//	登录方式
    //         if_success,//	是否成功
    //         if_logoff_apply,//	是否在注销申请中
    //         apply_day,//	申请注销剩余天数
    //     })
    // },
    // //序号12-SendSMS-发送短信验证码
    // $sendSms(process_name: any, if_success: any) {
    //     sensors.track('SendSMS', {
    //         process_name,//	流程名称
    //         if_success,//	是否成功
    //     })
    // },
    // //序号13-Register-登录发起
    // $register(register_mode: any, if_success: any) {
    //     sensors.track('Register', {
    //         register_mode,//	注册方式
    //         if_success,//	是否成功
    //     })
    // },
    //***********************************************注销************************************************************* 
    //序号31-LogOffApply-注销申请
    $logOffApply() {
        sensors.track('LogOffApply', {})
    },
    // //序号32-LogOffResult-注销结果
    // $logOffResult(apply_day: any, if_success: any) {
    //     sensors.track('LogOffResult', {
    //         apply_day,//	申请注销天数
    //         if_success,//	是否成功
    //     })
    // },
}